
export interface OperationMode {
  readonly canChangeCount: boolean
  readonly canRemove: boolean
}

interface OperationModes {
  readonly readOnly: OperationMode
  readonly onlyChangeCount: OperationMode
  readonly editable: OperationMode
}
export const operationModes: OperationModes = {
  readOnly: {
    canChangeCount: false,
    canRemove: false,
  },
  onlyChangeCount: {
    canChangeCount: true,
    canRemove: false,
  },
  editable: {
    canChangeCount: true,
    canRemove: true,
  },
}
